import { ViewModel } from "../../settings/viewModel";
import { PlotDefinition, ChartType } from "../../definitions";
import { HorizontalPlotter } from "./horizontalPlotter";

export class ActualAbsoluteTablePlotter extends HorizontalPlotter {
    constructor(
        viewModel: ViewModel,
        width: number,
        height: number,
        reportArea: d3.Selection<SVGElement, any, any, any>,
        svg: d3.Selection<SVGElement, any, any, any>,
        locale: string
    ) {
        super(viewModel, width, height, reportArea, svg, locale);
    }

    protected getPlotDefinition(): PlotDefinition {
        let plotDefinition = this.getBlankPlotDefinition(0);
        this.addValueColumns(plotDefinition, ChartType.Table);
        this.addAbsoluteDifferenceColumns(plotDefinition, ChartType.Table);
        return plotDefinition;
    }
}
